import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import './style.css';
import { Section } from '../../atom/section/Section';

type Props = {
	className?: string;
	style?: Record<string, unknown>;
	float?: boolean;
	theme?: 'light' | 'dark';
	type?: 'default' | 'horizontal';
};

export const Trustpilot = ({
	className,
	style,
	theme = 'light',
	float = false,
	type = 'default',
}: Props) => {
	if (type === 'horizontal') {
		return <Horizontal theme={theme} />;
	}
	return (
		<Default className={className} style={style} float={float} theme={theme} />
	);
};

const Default = ({ style, float, className, theme }) => {
	const ref = useRef(null);
	useEffect(() => {
		const loadTrustpilot = () => {
			if (typeof window !== 'undefined' && window.Trustpilot) {
				window.Trustpilot.loadFromElement(ref.current, true);

				clearInterval(interval);
			}
		};

		const interval = setInterval(loadTrustpilot, 1000);
	}, []);
	return (
		<div
			className={clsx('trustpilot', { '--float': !!float }, className)}
			style={style}
			ref={ref}
			data-template-id="53aa8912dec7e10d38f59f36"
			data-businessunit-id="5f683fa044436a0001778463"
			data-locale="en-US"
			data-style-width="100%"
			data-style-height="140px"
			data-stars="4,5"
			data-theme={theme}
		>
			<a
				href="https://www.trustpilot.com/review/cashflowfinance.com.au"
				target="_blank"
				rel="noopener"
			>
				Trustpilot
			</a>
		</div>
	);
};

const Horizontal = ({ theme }) => {
	const ref = useRef(null);
	useEffect(() => {
		const loadTrustpilot = () => {
			if (typeof window !== 'undefined' && window.Trustpilot) {
				window.Trustpilot.loadFromElement(ref.current, true);

				clearInterval(interval);
			}
		};

		const interval = setInterval(loadTrustpilot, 1000);
	}, []);
	return (
		<div
			ref={ref}
			className="trustpilot-widget"
			data-locale="en-US"
			data-template-id="5406e65db0d04a09e042d5fc"
			data-businessunit-id="5f683fa044436a0001778463"
			data-style-height="28px"
			data-style-width="100%"
			data-theme={theme}
		>
			<a
				href="https://www.trustpilot.com/review/earlypay.com.au"
				target="_blank"
				rel="noopener"
			>
				Trustpilot
			</a>
		</div>
	);
};
const Wrapper = ({ float, children }) => {
	if (float) {
		return <>{children}</>;
	}

	return <Section>{children}</Section>;
};
